import * as http from '../../modules/http';
import * as UrlParamsManager from '../../modules/UrlParamsManager';
import * as TextManager from "../../modules/languages/TextManager";

export const MAIN_DASHBOARD_REQUEST_START = 'MAIN_DASHBOARD_REQUEST_START';
export const MAIN_DASHBOARD_REQUEST_SUCCESS = 'MAIN_DASHBOARD_REQUEST_SUCCESS';
export const MAIN_DASHBOARD_REQUEST_FAILED = 'MAIN_DASHBOARD_REQUEST_FAILED';
export const MAIN_DASHBOARD_REQUEST_NO_PERMISSION = 'MAIN_DASHBOARD_REQUEST_NO_PERMISSION';
export const MAIN_DASHBOARD_HIDE_HELLO = 'MAIN_DASHBOARD_HIDE_HELLO';
export const MAIN_DASHBOARD_SHOW_HELLO = 'MAIN_DASHBOARD_SHOW_HELLO';

export function main_dashbaord_request_start(country,date,product,platform) {
    return {
        type: MAIN_DASHBOARD_REQUEST_START,
        country:country,
        date:date,
        product:product,
        platform:platform
    };
}

export function main_dashbaord_request_success(data) {
    return {
        type: MAIN_DASHBOARD_REQUEST_SUCCESS,
        data:data
    };
}

export function main_dashbaord_request_failed() {
    return {
        type: MAIN_DASHBOARD_REQUEST_FAILED
    };
}

export function main_dashbaord_request_no_permission() {
    return {
        type: MAIN_DASHBOARD_REQUEST_NO_PERMISSION
    };
}

export function main_dashbaord_show_hello() {
    return {
        type: MAIN_DASHBOARD_SHOW_HELLO
    };
}

export function main_dashbaord_hide_hello() {
    return {
        type: MAIN_DASHBOARD_HIDE_HELLO
    };
}


//
//
//Async Actions
//
//

export function fetchMainDashboardDataIfNeeded(queryParams) {
    var country = UrlParamsManager.getCountry(queryParams);
    var date = UrlParamsManager.getDate(queryParams);
    var product = UrlParamsManager.getProduct(queryParams);
    var platform = UrlParamsManager.getPlatform(queryParams);
    var accountID = UrlParamsManager.getAccount(queryParams);

    return (dispatch, getState) => {
        if (shouldFetchMainDashboardData(getState(),country,date,product,platform, accountID)) {
            return dispatch(fetchMainDashboardData(country,date,product,platform, accountID));
        }
    };
}

function shouldFetchMainDashboardData(state,country,product,date,platform, accountID) {
    if (!state.mainDashboard.data){
        return true;
    }
    else if (state.mainDashboard.country !== country ||
        state.mainDashboard.date !== date ||
        state.mainDashboard.platform !== platform ||
        state.mainDashboard.product !== product ||
        state.mainDashboard.accountID !== accountID){
        return true;
    }
    else{
        return false;
    }
}


function fetchMainDashboardData(country,date,product,platform, accountID) {

    var dateFilter = {
        filter:true,
        platform:platform,
        value:date.date,
        range:{startDate:date.startDate,endDate:date.endDate}
    };

    var requestParams = {date:dateFilter, country:country,product:product,platform:platform, accountID: parseInt(accountID)};

    return ((dispatch) => {
        dispatch(main_dashbaord_request_start(country,date,product,platform));

        let request = 'dashboard/data';

        http.postToServer(request,
            requestParams,
            (response) =>  {dispatch(main_dashbaord_request_success(response.data))},
            (response) =>  {dispatch(main_dashbaord_request_failed())},
            (response) =>  {dispatch(main_dashbaord_request_no_permission())}

        );

    });
}